import create from 'zustand';

const useRol = create(set => ({
    rol: false,
    setRol: (status) => set(state => ({ rol: status })),
}))

export {useRol}